import React from 'react';
import { View } from 'react-native';
import moment from 'moment';
import { Text } from '@/components/Text';
import { useStoreState } from '@/stores/store';
import colors, { appTheme } from '@/config/colors';
import { Divider } from 'react-native-elements';
import { Button } from '@/components/ui/therapist/Button';
import { Icon } from '@/components/Icon';

import { styles } from './styles';

export const ConnectionStatusCard = () => {
  const storedUser = useStoreState((state) => state.signedInUser);

  const epaLastUpdatedAt = moment(
    storedUser.user?.userEpa?.epaLastUpdatedAt,
  ).format('DD.MM.YYYY, HH:mm [Uhr]');

  return (
    <View style={[styles.cardContainer, { width: '100%' }]}>
      <View style={[styles.cardSection, styles.headingRow]}>
        <Icon
          name="checkCircle"
          size={20}
          color={appTheme.primary}
          style={styles.headingIcon}
        />
        <Text style={styles.heading}>Verbindungsstatus</Text>
      </View>
      <Divider color={colors.lightGrey} width={2} />

      <View style={[styles.cardSection, styles.rowBetween]}>
        <View>
          <Text style={styles.text}>GesundheitsID</Text>
          <View style={styles.statusPill}>
            <Icon
              name="checkCircle"
              size={16}
              color={appTheme.primary}
              style={styles.headingIcon}
            />
            <Text style={styles.statusPillText}>Verbunden</Text>
          </View>
        </View>
        <Button label="Verbindung trennen" look="danger" onPress={() => {}} />
      </View>
      <Divider color={colors.lightGrey} width={2} />

      <View style={[styles.cardSection, styles.rowBetween]}>
        <Text style={styles.text}>Letztes ePA Update</Text>
        <Text style={[styles.text, styles.textBold]}>{epaLastUpdatedAt}</Text>
      </View>

      <View style={styles.infoBanner}>
        <Icon
          name="circleInfo"
          size={18}
          color={appTheme.primary}
          style={styles.headingIcon}
        />
        <Text style={[styles.textSmall, styles.infoBannerText]}>
          Sie können sich nun auch mit Ihrer GesundheitsID in der neolexon App
          einloggen.
        </Text>
      </View>
    </View>
  );
};
